import { useLayoutEffect, useRef } from 'react';
import type { CSSProperties } from 'react';
import type { Bloco } from './blocos';

/**
 * Renderiza os blocos fora da tela, na largura exata do miolo A4, para medir
 * a altura real de cada um. É o que permite paginar sem cortar conteúdo.
 */
export function MedidorBlocos({ blocos, densidade, aoMedir }: {
  blocos: Bloco[];
  densidade: number;
  aoMedir: (alturas: Record<string, number>) => void;
}) {
  const raiz = useRef<HTMLDivElement>(null);
  const ultimas = useRef<Record<string, number>>({});

  useLayoutEffect(() => {
    const elemento = raiz.current;
    if (!elemento) return;

    const medidas: Record<string, number> = {};
    elemento.querySelectorAll<HTMLElement>('[data-bloco]').forEach((no) => {
      const id = no.dataset.bloco;
      if (id) medidas[id] = Math.ceil(no.getBoundingClientRect().height);
    });

    const anterior = ultimas.current;
    const chaves = Object.keys(medidas);
    const igual = chaves.length === Object.keys(anterior).length
      && chaves.every((chave) => anterior[chave] === medidas[chave]);
    if (igual) return;

    ultimas.current = medidas;
    aoMedir(medidas);
  });

  return (
    <div className="manual-medidor" aria-hidden="true" ref={raiz}>
      <div className="manual-paper manual-inner-page">
        <div className="manual-doc-body" style={{ '--manual-densidade': densidade / 100 } as CSSProperties}>
          {blocos.map((bloco) => (
            <div key={bloco.id} className="manual-bloco-doc" data-bloco={bloco.id}>{bloco.conteudo}</div>
          ))}
        </div>
      </div>
    </div>
  );
}
